<template>
  <div class="mainContainer">
    <div class="tabs">
      <div @click="typeFun(14)" class="left" :class="{ active: searchForm.type === 14 }">港口库房</div>
      <div @click="typeFun(27)" class="right" :class="{ active: searchForm.type === 27 }">港口库房补结算对账单</div>
    </div>
    <div class="nav" v-if="searchForm.type === 14">
      <el-form :model="searchForm" label-width="130px" :inline="true">
        <el-form-item label="对账单编号：">
          <el-input v-model="searchForm.settNo" size="mini" placeholder="请输入对账单编号" />
        </el-form-item>
        <el-form-item label="标题：">
          <el-input v-model="searchForm.title" size="mini" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="环节：">
          <el-select v-model="searchForm.typeIpt" size="mini" filterable placeholder="请选择环节" value-key="id">
            <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式：">
          <el-select v-model="searchForm.settType" size="mini" filterable placeholder="请选择结算方式" value-key="id">
            <el-option v-for="item in settTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.companyName" size="mini" placeholder="请输入供应商" />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="searchForm.status" size="mini" filterable placeholder="请选择状态" value-key="id">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="对账人员：">
          <el-input v-model="searchForm.reconciliator" size="mini" placeholder="请输入对账人员" />
        </el-form-item>
        <el-form-item label="对账单生成时间：">
          <el-date-picker v-model="settDate" size="mini" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"> </el-date-picker>
        </el-form-item>
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.consignor" size="mini" placeholder="请输入委托商" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" style="margin-left: 10px" class="searchBtn" @click="searchBtn"> 查询 </el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row v-if="searchForm.type === 14">
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span style="color: red;">{{ msg }}</span>
        <span @click="exportData">详情批量导出</span>
        <span @click="exportDatas">导出数据</span>
      </el-col>
    </el-row>
    <div class="content" v-if="searchForm.type === 14">
      <el-table ref="listTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" max-height="600px" border :header-cell-style="headerCellStyle" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }" :reserve-selection="true" @selection-change="selectionDataChange" :row-style="rowStyle">
        <el-table-column type="selection" align="center" min-width="50" />
        <el-table-column label="对账单编号" prop="settNo" align="center" width="140" />
        <el-table-column label="标题" prop="title" align="center" />
        <el-table-column prop="type" label="环节" width="140" align="center">
          <template slot-scope="scope">{{ scope.row.type | typeFormat }}</template>
        </el-table-column>
        <el-table-column label="结算方式" prop="settType" align="center" width="110" :formatter="settTypeFormat" />
        <el-table-column label="供应商" align="center" show-overflow-tooltip width="140">
          <template slot-scope="scope">
            {{ scope.row.companyNameNew }}
            <!-- 判断委托商是否 与原委托商相同  不同则展示         -->
            <el-tooltip v-if="scope.row.companyNameNew !== scope.row.companyNameOld" :content="`原结算单位：${scope.row.companyNameOld}`" placement="bottom" effect="light">
              <img v-if="scope.row.companyNameOld" alt="" :src="require('@/assets/images/warnning.png')" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="counts" label="数量" align="center" width="90px" />
        <el-table-column prop="settINum" label="结算数量" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="settlementPrice" label="结算金额（含税）" align="center" width="140px" />
        <el-table-column prop="otherPrice" label="其他费用金额（含税）" align="center" width="160px" />
        <el-table-column prop="adjustPrice" label="对账调整费用" align="center" width="160px" />
        <el-table-column prop="taxPrice" label="合计金额（含税）" align="center" width="130px">
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <span>{{ scope.row.settType === 1 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column label="税率（%）" prop="taxRate" align="center" width="90" />
        <el-table-column prop="deductAmount" label="抵扣费用" align="center" width="150" show-overflow-tooltip />
        <!-- <el-table-column label="发票号" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <span> {{ getInvoiceNo(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票时间" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <span>{{ getInvoiceCreateTime(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票金额" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <span>{{ getInvoicePrice(scope.row) }} </span>
          </template>
        </el-table-column>
        <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column> -->
        <el-table-column label="发票号" prop="invoiceNo" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发票时间" prop="invoiceDate" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发票金额" prop="invoicePrice" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发票代码" prop="invoiceCode" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="对账单生成时间" align="center" width="200" />
        <el-table-column label="状态" prop="status" align="center" :formatter="statusFormat" />
        <el-table-column label="推送状态" width="140" align="center" show-overflow-tooltip>
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <span>{{ scope.row.isSend==1?'已推送':'未推送' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reconciliator" label="对账人员" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="consignor" label="委托商" align="center" show-overflow-tooltip width="140" />
        <el-table-column prop="remark" label="备注" width="140" align="center" show-overflow-tooltip />

        <el-table-column label="操作" width="360" align="center" fixed="right">
          <template slot-scope="scope">
            <!--            <el-tooltip placement='bottom' effect='light'>
              <div slot='content'>
                <span style='color: rgb(16, 16, 16);font-weight: 700;'>提示</span><br />
                <span>
                  预结算超出合同价，已记录到
                  <span style='color: rgb(58, 98, 215);cursor: pointer;'
                        @click="$router.push('/settle/exceedContract');">
                    补结算管理
                  </span>
                  页面中，下次结算可以选择是否抵消当前超出费用！
                </span>
              </div>
              <i class='el-icon-warning' style='color: red;font-size: 18px;margin-right: 5px;' />
            </el-tooltip>-->
            <el-button v-if="scope.row.isHongchong != 1" size="mini" class="searchBtn btnTopBottom10" type="primary" @click="btnClick('info', scope.row)">详情 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" type="primary" @click="btnClick('submitReview', scope.row)" class="btnTopBottom10"> 提交审核 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 1" size="mini" type="danger" @click="btnClick('cancelReview', scope.row)" class="btnTopBottom10"> 取消审核 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0" size="mini" type="primary" @click="titleChange(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">更改标题 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 2" size="mini" type="primary" @click="fillInInvoice(scope.row.id, scope.row.reconciliator, scope.row)" class="btnTopBottom10">填写发票 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 3" size="mini" type="primary" @click="invoiceClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">寄送发票 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 5" size="mini" type="primary" @click="invoiceReceived(scope.row)" class="btnTopBottom10">确认收票 </el-button>
            <el-button v-if="scope.row.isSend != 1" size="mini" type="primary" @click="dataPush(scope.row.id, scope.row.reconciliator, scope)" class="btnTopBottom10">推送 </el-button>
            <el-button v-if="scope.row.isHongchong != 1 && scope.row.isSend == 1" size="mini" type="primary" @click="onClickVoid(scope.row)" class="btnTopBottom10">作废</el-button>
            <!-- <el-button v-if="scope.row.isHongchong != 1 && scope.row.isSend === 1" size="mini" type="primary" @click="cancelPush(scope.row.id)" class="btnTopBottom10">取消推送 </el-button> -->
            <el-button v-if="scope.row.isHongchong != 1" size="mini" type="info" @click="btnClick('delete', scope.row)" class="btnTopBottom10">删除 </el-button>
            <el-button v-if="scope.row.isHongchong != 1" size="mini" type="primary" @click="editRemark(scope.row)" class="btnTopBottom10">修改备注</el-button>
            <el-button v-if="scope.row.isHongchong != 1" size="mini" type="danger" @click="hongChong(scope.row)" class="btnTopBottom10">红冲</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <!-- 推送 -->
    <el-dialog title="选择推送" :visible.sync="dialogFormVisiblePush">
      <el-form :model="formPush" :inline="true">
        <el-form-item label="商品编号" label-width="120px">
          <el-select v-model="formPush.classbName" placeholder="请选择商品编号">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in productNumberOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票类型" label-width="120px">
          <el-select v-model="formPush.invoiceType" placeholder="请选择发票类型">
            <el-option :label="item.classaName" :value="item.classbName" v-for="(item, index) in invoiceTypeOption" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input type="textarea" v-model="formPush.remarks" placeholder="请输入发票备注" style="width: 460px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisiblePush = false">取 消</el-button>
        <el-button type="primary" :loading="pushLoading" @click="surePush">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <supplier-warehouse-statement-info ref="supplierWarehouseStatementInfoInfo" @exportData="exportData" />
    <!-- 提交审核 -->
    <submit-review ref="submitReviewRef" />
    <!-- 填写发票 -->
    <invoice-information ref="invoiceInformation" @getList="accountList" />
    <!-- 寄送发票 -->
    <send-invoice ref="sendInvoiceRef" @success="accountList" />
    <!-- 港口库房补结算对账单 -->
    <supplier-warehouse-reimbursement-statement v-if="searchForm.type === 27" />
  </div>
</template>

<script>
  import SupplierWarehouseStatementInfo from './components/info.vue';
  import SubmitReview from './components/submitReview';
  import { accountDelete, accountList, cancelApplyFor, receiveInvoice, submitAudit, changeTitle, cancellation, dataPush, remarkSubmit, hongChong,repeal} from '@/service/getData';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import invoiceInformation from '@/components/invoiceInformation';
  import SendInvoice from '@/components/sendInvoice';
  import supplierWarehouseReimbursementStatement from '@/views/settle/supplier/supplier-warehouse-statement/components/supplier-warehouse-reimbursement-statement.vue';
  import { paramCategoryPageList } from '@/service/basicfile';

  export default {
    name: 'supplierWarehouseStatement',
    components: {
      invoiceInformation,
      SubmitReview,
      SupplierWarehouseStatementInfo,
      SendInvoice,
      supplierWarehouseReimbursementStatement,
    },
    data() {
      return {
        activeRow: null,
        productNumberOption: [],
        invoiceTypeOption: [],
        formPush: {
          classbName: '',
          invoiceType: '',
          remarks: ''
        },
        dialogFormVisiblePush: false,
        pushLoading: false,
        pickerOptions: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              },
            },
          ],
        },
        settDate: ['', ''],
        searchForm: {
          type: 14,
          settNo: '',
          title: '',
          consignor: '',
          companyName: '',
          typeIpt: '',
          settType: '',
          status: '',
          reconciliator: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        msg: '',
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        settTypeOptions: [
          {
            label: '合同价',
            value: '1',
          },
          {
            label: '预结算价',
            value: '2',
          },
          {
            label: '合并价格',
            value: '3',
          },
        ],
        statusOptions: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待提交审核',
          },
          {
            value: 1,
            label: '审核对账单中',
          },
          {
            value: 2,
            label: '系统开票中',
          },
          {
            value: 3,
            label: '填写快递单号',
          },
          {
            value: 4,
            label: '已收款',
          },
          {
            value: -1,
            label: '审核未通过',
          },
          {
            value: -2,
            label: '系统开票失败',
          },
          {
            value: -10,
            label: '已取消',
          },
        ],
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '委托商运费',
          },
          {
            value: 2,
            label: '委托商港口费',
          },
          {
            value: 3,
            label: '暂无',
          },
          {
            value: 4,
            label: '公路供应商托运费',
          },
          {
            value: 5,
            label: '水路供应商运费',
          },
          {
            value: 6,
            label: '港口供应商操作费',
          },
          {
            value: 7,
            label: '港口供应商燃油费',
          },
          {
            value: 8,
            label: '港口堆存费',
          },
          {
            value: 9,
            label: '提车费',
          },
          {
            value: 13,
            label: '港口库房委托商结算',
          },
          {
            value: 14,
            label: '港口库房供应商结算(库房)',
          },
          {
            value: 15,
            label: '港口库房供应商结算(港口)',
          },
          {
            value: 17,
            label: '其他费用',
          },
        ],
        settlement: '',
        checkTableData: [], // 列表选中数据
      };
    },
    filters: {
      typeFormat(value) {
        switch (value) {
          case 1:
            return '委托商运费';
          case 2:
            return '委托商港口费';
          case 3:
            return '暂无';
          case 4:
            return '公路供应商托运费';
          case 5:
            return '水路供应商运费';
          case 6:
            return '港口供应商操作费';
          case 7:
            return '港口供应商燃油费';
          case 8:
            return '港口堆存费';
          case 9:
            return '提车费';
          case 13:
            return '港口库房委托商结算';
          case 14:
            return '港口库房供应商结算(库房)';
          case 15:
            return '港口库房供应商结算(港口)';
        }
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      //  this.searchBtn();
    },
    methods: {
      async onClickVoid(row) {
        console.log(row.id);
        const { status, message, data } = await repeal({id: row.id});
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.accountList();
      },
      async hongChong(row) {
        // console.log(row.id);
        this.$confirm('是否生成红冲对账单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const msg = this.$message({
            // showClose: true,
            iconClass: 'el-icon-loading',
            message: '生成红冲对账单中......'
          });
          const { status, message } = await hongChong({id: row.id});
          if (status !== 0) return this.$message.warning(message);
          msg.close()
          this.$message.success(message);
          this.searchBtn();
        })

      },
      async surePush() {
        this.pushLoading = true
        // let flag = true;
        // Object.keys(this.formPush).forEach((key) => {
        //   if (!this.formPush[key]) flag = false;
        // });
        // if (flag) {
          const params ={
            classbName: this.formPush.classbName,
            invoiceType: this.formPush.invoiceType,
            remarks: this.formPush.remarks,
            id:this.activeRow.id,
            reconciliator: this.activeRow.reconciliator,
          }
          const { status, message } = await dataPush(params);
          this.pushLoading = false
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.accountList();
          this.dialogFormVisiblePush = false
        // }

      },
      editRemark(row) {
        this.$prompt('备注', '更改备注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          inputValue: row.remark
        })
          .then(async ({ value }) => {
            const { status, message } = await remarkSubmit({
              id: row.id,
              remark: value
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.searchBtn();
          })
      },
      //获取发票号
      getInvoiceNo(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.invoiceNo).join(',');
        } else {
          return '';
        }
      },
      //获取发票时间
      getInvoiceCreateTime(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.createTime).join(',');
        } else {
          return '';
        }
      },
      //获取发票金额
      getInvoicePrice(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.taxPrice).join(',');
        } else {
          return '';
        }
      },
      async titleChange(id, reconciliator) {
        this.$prompt('标题', '更改标题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(async ({ value }) => {
            const { status, message } = await changeTitle({
              id,
              title: value,
              reconciliator,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消修改',
            });
          });
      },
      async exportDatas() {
        window.exportExcelAllFunc({
          type: 'get',
          url: '/customer/account/export',
          obj: {
            type: 14, // 供应商提车费结算对账单
            settNo: this.searchForm.settNo,
            title: this.searchForm.title,
            companyName: this.searchForm.companyName,
            startTime: this.settDate[0] ? this.settDate[0] : '',
            endTime: this.settDate[1] ? this.settDate[1] : '',
            status: this.searchForm.status,
            consignor: this.searchForm.consignor,
            page: this.searchForm.page,
            rows: this.searchForm.rows,
            id: this.checkTableData.map(item => item.id).join(',')
          }
        });
      },
      // 导出数据
      exportData() {
        if (this.checkTableData == 0) return this.$message.warning('请勾选数据后导出');
        const info = [];
        this.checkTableData.forEach(item => {
          const id = item.id;
          const settNo = item.settNo;
          const title = item.title;
          const customerName = item.companyNameNew;
          info.push({id, settNo, title,customerName});
        });
        // if (params['id']) {
          let token = getSessionStore('token');
          window.exportExcel(
            `${baseUrl}/platform/customer/accountPrice/exportSettlementSupplierPortAndWarehouseInfo?access_token=${token}`,
            {
              infoDtos:info
            },
            '结算费用',
          );
        // } else {
        //   let token = getSessionStore('token');
        //   const ids = this.checkTableData.map(item => item.id);
        //   window.exportExcel(
        //     `${baseUrl}/platform/customer/accountPrice/export?access_token=${token}`,
        //     {
        //       ...this.searchForm,
        //       startTime: this.settDate[0] ? this.settDate[0] : '',
        //       endTime: this.settDate[1] ? this.settDate[1] : '',
        //       ids,
        //     },
        //     '供应商港口库房对账单',
        //   );
          this.clearCheckTableData();
        // }
      },
      selectionDataChange(selection) {
        this.checkTableData = selection;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      invoiceClick(id, reconciliator) {
        this.$refs.sendInvoiceRef.invoiceOpen(id, reconciliator);
        this.searchBtn();
      },
      cancelPush(id) {
        this.$confirm('确定要取消推送当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await cancellation({ id });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      async dataPush(id, reconciliator, scope) {
        this.activeRow = scope.row;
        let productNumber = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'ac81ffe0197e4de19b7137dcb98f7784',
        });
        if (productNumber.status !== 0) return this.$message.warning(productNumber.message);

        this.productNumberOption = productNumber.data.records;

        let invoiceTypes = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'cf503167d28740f4b69aad91eb8dfd70',
        });
        if (invoiceTypes.status !== 0) return this.$message.warning(invoiceTypes.message);
        this.invoiceTypeOption = invoiceTypes.data.records;

        this.formPush.invoiceType = '';
        this.formPush.classbName = '';
        this.dialogFormVisiblePush = true;
        // this.$confirm('确定要推送当前数据吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        // })
        //   .then(async () => {
        //     const { status, message } = await dataPush(id, reconciliator);
        //     if (status !== 0) return this.$message.warning(message);
        //     this.$message.success(message);
        //     await this.accountList();
        //   })
        //   .catch(() => {});
      },
      invoiceReceived(row) {
        this.$confirm('您确认已经收票么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await receiveInvoice(row.id, row.reconciliator);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      fillInInvoice(id, reconciliator, row) {
        this.$refs.invoiceInformation.openDialog(id, reconciliator);
        this.$refs.invoiceInformation.setTaxRate(row.taxRate);
        this.searchBtn();
      },
      async accountList() {
        const obj = {
          type: 14, // 供应商提车费结算对账单
          settNo: this.searchForm.settNo,
          title: this.searchForm.title,
          companyName: this.searchForm.companyName,
          startTime: this.settDate[0] ? this.settDate[0] : '',
          endTime: this.settDate[1] ? this.settDate[1] : '',
          status: this.searchForm.status,
          consignor: this.searchForm.consignor,
          page: this.searchForm.page,
          rows: this.searchForm.rows,
        };
        this.tableLoading = true;
        const res = await accountList(obj);
        this.tableLoading = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          return;
        }
        this.total = res.data.total;
        this.tableData = res.data.records;
        this.msg = res.msg;
      },
      clearCheckTableData() {
        this.$refs.listTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      statusFormat(r, c, cellValue) {
        switch (cellValue) {
          case 0:
            return '待提交审核';
          case 1:
            return '审核对账单中';
          case 2:
            return '系统开票中';
          case 3:
            return '填写快递单号';
          case 4:
            return '已收款';
          case 5:
            return '发票寄送中';
          case 6:
            return '待财务审核';
          case 7:
            return '待提交开票';
          case 8:
            return '待打印发票';
          case 9:
            return '待财务核销';
          case 10:
            return '待复核确认';
          case 11:
            return '待财务确认';
          case 12:
            return '已完成';
          case -1:
            return '审核未通过';
          case -2:
            return '系统开票失败';
          case -10:
            return '已取消';
        }
      },
      settTypeFormat(r, c, cellValue) {
        switch (cellValue) {
          case 1:
            return '合同价';
          case 2:
            return '预结算价';
          case 3:
            return '合并价格';
        }
      },
      // 港口库房/港口库房补结算对账单 切换
      typeFun(val) {
        this.searchForm.type = val;
        //  this.searchBtn();
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.settDate = ['', ''];
      },
      // 获取表格数据
      async getTableData() {
        await this.accountList();
      },
      btnClick(str, row) {
        switch (str) {
          case 'info':
            this.$refs.supplierWarehouseStatementInfoInfo.dialogOpen(row.id, row.settNo);
            break;
          case 'submitReview':
            this.submitReview(row.id, row.reconciliator);
            break;
          case 'cancelReview':
            this.cancelReview(row.id, row.reconciliator);
            break;
          case 'delete':
            this.deleteData(row.id, row.reconciliator);
            break;
        }
      },
      submitReview(id, reconciliator) {
        this.$confirm('确认提交审核么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await submitAudit({
            isDetailedList: 0,
            id,
            type: 14,
            reconciliator,
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.getTableData();
        });
      },
      cancelReview(id, reconciliator) {
        this.$confirm('确认要取消审核申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await cancelApplyFor(id, reconciliator);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.getTableData();
        });
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id, reconciliator) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await accountDelete(id, reconciliator);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn();
        });
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 260px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        width: 100px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-right: 20px;
        width: 140px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }
    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
  .btnTopBottom10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
